const regHex = /^0x[0-9a-fA-F]*$/;

export type Hex = `0x${string}`;

export const isHex = (value: unknown): value is Hex =>
  value && typeof value === "string" && regHex.test(value);
